module.exports = __webpack_public_path__ + "static/img/store-icon9.5fdd01c.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon9.png
// module id = 69on
// module chunks = 1